var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.72,7.57l-5.3-5.29A1,1,0,0,0,15.74,2H8.25a1,1,0,0,0-.68.28L2.28,7.57A1,1,0,0,0,2,8.25v7.5a1,1,0,0,0,.28.68l5.29,5.29a1,1,0,0,0,.68.28h7.49a1,1,0,0,0,.68-.28l5.3-5.29a1,1,0,0,0,.28-.68V8.25A1,1,0,0,0,21.72,7.57Zm-1.94,7.65h0L15.5,19.5a1,1,0,0,1-.68.28H9.17a1,1,0,0,1-.68-.28l-4-4a1,1,0,0,1-.28-.68V9.18A1,1,0,0,1,4.5,8.5l4-4a1,1,0,0,1,.68-.28h5.65a1,1,0,0,1,.68.28l4,4a1,1,0,0,1,.29.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,14.53a.84.84,0,1,0,.84.84A.84.84,0,0,0,12,14.53Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.15,
    y: 7.79,
    width: 1.69,
    height: 5.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e01182b9a7ea6ebefa0e406e896122e6.svg";
export { ForwardRef as ReactComponent };